export default __webpack_public_path__ + "static/media/Imanishi.430c787b.jpg";